import { withStyles } from '@material-ui/core/styles';
import Input from './Input';
import styles from './Input.styles';

export default withStyles(styles)(Input);
